import { render, staticRenderFns } from "./TransporterTable.vue?vue&type=template&id=438fced5&scoped=true&"
import script from "./TransporterTable.vue?vue&type=script&lang=js&"
export * from "./TransporterTable.vue?vue&type=script&lang=js&"
import style0 from "./TransporterTable.vue?vue&type=style&index=0&id=438fced5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438fced5",
  null
  
)

export default component.exports